// FIXME use cross-fetch
import fetchPonyfill from 'fetch-ponyfill';

const {fetch, Request, Response, Headers} = fetchPonyfill({Promise});

export default fetch;
export {Request, Response, Headers};
